<template>
  <v-row v-if="options && options.type === 'summary'" class="align-center">
    <v-col cols="12" sm="4" class="py-0 text-sm-right">
      <span class="caption" style="line-height: 0.9rem !important;">{{ title }}</span>
    </v-col>
    <v-col class="py-0 d-flex">
      <v-progress-linear
          v-for="bar in 10"
          :key="'bar-'+bar"
          :height="bar_options.height"
          background-opacity="0.15"
          :color="bar_color"
          :background-color="bar_backs[bar]"
          rounded
          :value="Math.round(value) === bar ? 100 : 0"
          :class="{'mr-1': bar < 10}"
      ></v-progress-linear>
    </v-col>
    <v-col class="py-0 pl-0" style="max-width:50px;">
      <span class="caption"><span class="grey--text" v-if="options && options.average">Ø </span>{{scoreNum(value)}}</span>
    </v-col>
  </v-row>

  <div v-else-if="options && options.type==='result'" class="d-flex align-center" style="max-width:450px;width: 100%;">
    <v-spacer></v-spacer>
    <div class="d-flex mr-2" style="width:100%">
      <v-progress-linear
          v-for="bar in 10"
          :key="'bar-'+bar"
          :height="bar_options.height"
          background-opacity="0.15"
          :color="bar_color"
          :background-color="bar_backs[bar]"
          rounded
          :value="Math.round(value) === bar ? 100 : 0"
          :class="{'mr-1': bar < 10}"
      ></v-progress-linear>
    </div>
    <strong style="width:25px;"><span class="grey--text" v-if="options && options.average">Ø </span>{{scoreNum(value)}}</strong>
  </div>

  <div v-else-if="options && options.type === 'title_bar' && options.values"
       class="d-none d-sm-flex align-center"
       :style="{width:getWidth()}">
    <v-progress-linear
        v-for="(bar,index) in options.values"
        :key="'bar-'+index"
        :height="bar_options.height"
        background-opacity="0.15"
        :color="bar_backs[Math.round(bar)]"
        rounded
        :value="100"
        :class="{'mr-1': index < options.values.length-1}"
    ></v-progress-linear>
  </div>

  <div v-else-if="options && options.type === 'inline'"
       class="d-inline-block mr-1"
       style="width: 27px;">
    <v-progress-linear
        :height="bar_options.height"
        background-opacity="0.15"
        :color="bar_backs[Math.round(value)]"
        rounded
        :value="100"
        class="mr-1"
    ></v-progress-linear>
  </div>

  <div v-else-if="options && options.type === 'stack'" class="d-flex flex-column align-center">
    <v-progress-linear
        v-for="bar in [10,8,6,4,2]"
        :key="'bar-'+bar"
        :height="bar_options.height"
        background-opacity="0.15"
        :color="bar_color"
        :background-color="bar_backs[bar]"
        rounded
        :value="Math.round(value) >= bar -1 && Math.round(value) < bar +1 ? 100 : 0"
        :class="{'mb-1': bar > 1}"
        style="max-width:90px"
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "ScoreBar",
  props: ['title','value','options'],
  data() {
    return {
      bar_color: 'back_accent'
    }
  },
  computed: {
    bar_backs() {
      let result_colors =  this.$store.getters['app/colors']
      let backs = {
        1: result_colors['red'],
        2: result_colors['lred'],
        3: result_colors['yellow'],
        4: result_colors['yellow'],
        5: result_colors['green'],
        6: result_colors['green'],
        7: result_colors['yellow'],
        8: result_colors['yellow'],
        9: result_colors['lred'],
        10:result_colors['red']
      }
      let backs2 = {
        1: result_colors['red'],
        2: result_colors['red'],
        3: result_colors['lred'],
        4: result_colors['lred'],
        5: result_colors['yellow'],
        6: result_colors['yellow'],
        7: result_colors['lgreen'],
        8: result_colors['lgreen'],
        9: result_colors['green'],
        10:result_colors['green']
      }
        let backs3 = { // team
            1: result_colors['red'],
            2: result_colors['red'],
            3: result_colors['lred'],
            4: result_colors['yellow'],
            5: result_colors['green'],
            6: result_colors['green'],
            7: result_colors['yellow'],
            8: result_colors['lred'],
            9: result_colors['red'],
            10:result_colors['red']
        }
      if (this.options.scale && this.options.scale === 2) {
        return backs2
      } else if (this.options.scale && this.options.scale === 3) {
        return backs3
      } else {
        return backs
      }
    },
    bar_options() {
      let height = 7
      if (this.options && this.options.height) {
        height = this.options.height
      }else if (this.options && this.options.type === 'result') {
        height = 9
      } else if (this.options && this.options.type === 'inline') {
        height = 8
      }
      return {height: height}
    }
  },
  methods: {
    scoreNum(score){
      if (score < 9.947) {
        return score.toFixed(1)
      } else {
        return 10
      }
    },
    getSummaryColor() {
      let scale = this.options.scale ? this.options.scale : 1
      this.$store.dispatch('app/getSummaryColor',{scores:[this.value],type:scale}).then(score_color => {
        this.bar_color = score_color
      })
    },
    getWidth() { //title_bar
      return 32 * this.options.values.length + 'px'
    }
  },
  created() {
    this.getSummaryColor()
  }
}
</script>